import { render, staticRenderFns } from "./TeethListPanel.vue?vue&type=template&id=5c36cfe3&scoped=true&"
import script from "./TeethListPanel.vue?vue&type=script&lang=js&"
export * from "./TeethListPanel.vue?vue&type=script&lang=js&"
import style0 from "./TeethListPanel.vue?vue&type=style&index=0&id=5c36cfe3&prod&scoped=true&lang=css&"
import style1 from "./TeethListPanel.vue?vue&type=style&index=1&id=5c36cfe3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36cfe3",
  null
  
)

export default component.exports